import { api } from './graphql';

api.enhanceEndpoints({
  endpoints: {
    GetAdminFeatureFlags: { providesTags: ['FeatureFlag'] },
    GetAdminFeatureFlag: { providesTags: ['FeatureFlag'] },
    GetAdminFeatureFlagHolderCounts: { providesTags: ['FeatureFlag', 'AdminTenantFeatures', 'AdminTenant'] },
    GetAdminFeatureFlagHolders: { providesTags: ['FeatureFlag', 'AdminTenantFeatures', 'AdminTenant'] },
    ActivateAdminFeatureFlag: { invalidatesTags: ['FeatureFlag'] },
    InactivateAdminFeatureFlag: { invalidatesTags: ['FeatureFlag'] },
    SetAdminFeatureFlagGlobalValue: { invalidatesTags: ['FeatureFlag'] },
    SetAdminFeatureFlagTenantOverrides: { invalidatesTags: ['FeatureFlag'] },
    SetAdminFeatureFlagTenantOverride: { invalidatesTags: ['FeatureFlag'] },
    ClearAdminFeatureFlagTenantOverride: { invalidatesTags: ['FeatureFlag'] },
  },
});
